import React, { useEffect, useState } from "react";
import api from "../api";
import { StackEditor } from "./StackEditor";
import { SynergyEditor } from "./SynergyEditor";

// Admin → Recommendations: edit Research Stacks and per-product complementary compounds.
export default function RecommendationsTab() {
  const [products, setProducts] = useState([]);
  useEffect(() => {
    api.get("/products").then(({ data }) => {
      const list = Array.isArray(data) ? data : data.products || [];
      setProducts([...list].sort((a, b) => a.name.localeCompare(b.name)));
    });
  }, []);

  return (
    <div data-testid="recommendations-tab" className="space-y-14">
      <StackEditor products={products} />
      <div className="border-t border-white/10 pt-10">
        <SynergyEditor products={products} />
      </div>
    </div>
  );
}
